import React from 'react';
import styles from './DocumentDefaultTemplate.module.css';
import Header from './header/Header';
import Footer from './footer/Footer';
import RemotePath from '../../consts/RemotePaths';

const formatCurrency = (value) => {
    const num = parseFloat(value) || 0;
    return num.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};

const BudgetTemplate = React.forwardRef(function BudgetTemplate(
    { companyData, budgetData, date, professionalName },
    ref
) {
    const {
        customer = {},
        items = [],
        discount = 0,
        subtotal = 0,
        total = 0,
        validUntil = '',
        notes = '',
    } = budgetData || {};

    const hasDiscount = parseFloat(discount) > 0;
    const hasCustomer = customer.name || customer.cpf || customer.phone || customer.email;

    // Logo: se for base64 usa direto; senão constrói URL completa via RemotePath
    const logoSrc = companyData?.Logo
        ? companyData.Logo.startsWith('data:')
            ? companyData.Logo
            : (companyData.Id
                ? RemotePath.PATH_USER_UPLOADS_COMPANY_LOGO(companyData.Id) + companyData.Logo
                : '')
        : '';

    const fullAddress = companyData
        ? [
            companyData.Address,
            companyData.Number,
            companyData.Complement,
            companyData.District,
            companyData.City,
            companyData.State,
          ].filter(Boolean).join(', ')
        : '';

    return (
        <div ref={ref} className={styles.paper}>
            <div className={styles.content}>
                <div>
                    <Header
                        logo={logoSrc}
                        title={companyData?.Name || ''}
                        address={fullAddress}
                        CNPJ={companyData?.CNPJ || ''}
                        phone={companyData?.Phone || ''}
                    />

                    <div style={{ marginTop: '20px', marginBottom: '10px' }}>
                        <h2 style={{ margin: 0 }}>Orçamento</h2>
                        {date && <p style={{ margin: '4px 0 0 0', fontSize: '0.85rem', color: '#666' }}>Emitido em: {date}</p>}
                    </div>

                    {/* Dados do interessado */}
                    {hasCustomer && (
                        <div style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', padding: '20px', borderRadius: '10px', border: '1px solid #d3d3d3', flex: 1 }}>
                                {customer.name && <div style={{ display: 'flex', gap: '10px' }}><p>Nome:</p><p><b>{customer.name}</b></p></div>}
                                {customer.cpf && <div style={{ display: 'flex', gap: '10px' }}><p>CPF:</p><p><b>{customer.cpf}</b></p></div>}
                                {customer.phone && <div style={{ display: 'flex', gap: '10px' }}><p>Telefone:</p><p><b>{customer.phone}</b></p></div>}
                                {customer.email && <div style={{ display: 'flex', gap: '10px' }}><p>E-mail:</p><p><b>{customer.email}</b></p></div>}
                            </div>
                        </div>
                    )}

                    {/* Tabela de itens */}
                    <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '16px' }}>
                        <thead>
                            <tr style={{ backgroundColor: '#f5f5f5', borderBottom: '2px solid #d3d3d3' }}>
                                <th style={{ textAlign: 'left', padding: '8px 10px', fontSize: '0.85rem' }}>Descrição</th>
                                <th style={{ textAlign: 'center', padding: '8px 10px', fontSize: '0.85rem', width: '60px' }}>Qtd</th>
                                <th style={{ textAlign: 'right', padding: '8px 10px', fontSize: '0.85rem', width: '120px' }}>Valor Unit.</th>
                                <th style={{ textAlign: 'right', padding: '8px 10px', fontSize: '0.85rem', width: '120px' }}>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.length > 0 ? (
                                items.map((item, index) => (
                                    <tr key={index} style={{ borderBottom: '1px solid #e0e0e0', backgroundColor: index % 2 === 0 ? '#fff' : '#fafafa' }}>
                                        <td style={{ padding: '8px 10px', fontSize: '0.85rem' }}>{item.description}</td>
                                        <td style={{ padding: '8px 10px', fontSize: '0.85rem', textAlign: 'center' }}>{item.quantity}</td>
                                        <td style={{ padding: '8px 10px', fontSize: '0.85rem', textAlign: 'right' }}>{formatCurrency(item.unitPrice)}</td>
                                        <td style={{ padding: '8px 10px', fontSize: '0.85rem', textAlign: 'right', fontWeight: 500 }}>{formatCurrency(item.totalPrice)}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={4} style={{ padding: '16px', textAlign: 'center', color: '#999', fontSize: '0.85rem' }}>
                                        Nenhum item adicionado.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                    {/* Totais */}
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', minWidth: '220px', border: '1px solid #d3d3d3', borderRadius: '8px', padding: '12px 16px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '24px' }}>
                                <span style={{ fontSize: '0.85rem', color: '#666' }}>Subtotal:</span>
                                <span style={{ fontSize: '0.85rem' }}>{formatCurrency(subtotal)}</span>
                            </div>
                            {hasDiscount && (
                                <div style={{ display: 'flex', justifyContent: 'space-between', gap: '24px' }}>
                                    <span style={{ fontSize: '0.85rem', color: '#666' }}>Desconto:</span>
                                    <span style={{ fontSize: '0.85rem', color: '#e53935' }}>- {formatCurrency(discount)}</span>
                                </div>
                            )}
                            <hr style={{ border: 'none', borderTop: '1px solid #d3d3d3', margin: '4px 0' }} />
                            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '24px' }}>
                                <span style={{ fontSize: '0.9rem', fontWeight: 700 }}>Valor Total:</span>
                                <span style={{ fontSize: '0.9rem', fontWeight: 700 }}>{formatCurrency(total)}</span>
                            </div>
                        </div>
                    </div>

                    {/* Validade */}
                    {validUntil && (
                        <p style={{ fontSize: '0.85rem', color: '#444', marginBottom: '12px' }}>
                            <strong>Válido até:</strong> {validUntil}
                        </p>
                    )}

                    {/* Observações */}
                    {notes && (
                        <div style={{ border: '1px solid #d3d3d3', borderRadius: '8px', padding: '12px 16px', marginBottom: '12px' }}>
                            <p style={{ fontSize: '0.75rem', fontWeight: 600, textTransform: 'uppercase', color: '#666', margin: '0 0 6px 0' }}>Observações</p>
                            <p style={{ fontSize: '0.85rem', color: '#444', whiteSpace: 'pre-wrap', margin: 0 }}>{notes}</p>
                        </div>
                    )}
                </div>

                <Footer />
            </div>
        </div>
    );
});

export default BudgetTemplate;
